const routes = [
  {
    path: 'deepclone',
    name: 'deepclone',
    component: () => import(/* webpackChunkName: "deepclone" */ '@/modules/deepclone/index.vue')
  },
];

export default routes;